import type { RecurrencesMap } from '../../typings'

import { Calendar } from './components/Calendar'

import { useAnnualCalendarProps } from './useAnnualCalendarProps'

type Props = {
  recurrenceMap: RecurrencesMap
  onChange: (date: Date) => void
  date: Date | null
}

export function AnnualCalendar(props: Props) {
  const { recurrenceMap, onChange } = props
  const calendarProps = useAnnualCalendarProps(recurrenceMap, onChange)

  return <Calendar {...calendarProps} />
}
